export const STORAGE = {
    htmlCacheKey: "mng-auth-html",
    initOptionsCacheKey: "mng-auth-init-options",
    notAuthenticatedCheckSessionKey: "mng-auth-not-authenticated-check",
    entitlementCookieKey: "mng-entitlements",
    sessionLocalStorageKey: "__MNG_Session",
    entitlementJWTDecodedKey: "mng-jwt-decoded", 
    engageAuth0Sub: "nxt_auth0_sub",
    regwallUserIsSubscribed: 'regwallUserIsSubscribed',
}
